import React from "react";

export default function PageTitleNew({ title }) {
  return (
    <div className="invite_header">
      <div className="text_h3">{title}</div>
    </div>
  );
}
